import { useRef, useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import homeFiles from '../../../src/assets/homeFiles.json'
import styles from './home.module.css'

import constants from "../../constants.js";
import dummy from '../../dummyData.js';
import { useApiProvider } from '../../providers/ApiProvider.js';
import { useSidebarProvider } from '../../providers/SidebarProvider.js';

import Carousel from '../common/Carousel/Carousel.js';

const Home = ({setSelectedMenuItem, currentWeekMatchups, lastWeekMatchups}) => {
  const { setIsSidebarShowing } = useSidebarProvider();
  const { isLoading, LoadingSpinner } = useApiProvider();

  const navigate = useNavigate();
  const matchupCarouselRef = useRef(null);
  const newsLetterCarouselRef = useRef(null);
  const recapCarouselRef = useRef(null);


  //homeImage is just the index of the current option in the array
  const [homeImage, setHomeImage] = useState(0);
  
  const togglePicture = (e) => {
    if (e.currentTarget.name === "back") {
      if (homeImage > 0){
        setHomeImage(prev => prev - 1);
      }
    }
    else {
      if (homeImage < (homeFiles.length - 1)){
        setHomeImage(prev => prev + 1);
      }
    }
  }

  useEffect(() => {
    homeFiles.forEach(image => {
      const img = new Image();
      img.src = `/pictures/home/${image}`;
    });
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem("");
  },[homeFiles]);

  return (
    <div className={styles.Home}>
      <div className={styles.PicturesContainer} style={{backgroundImage: `url(pictures/Home/main/${homeFiles[homeImage]})`}}>
        <div className={styles.PicturesText}>
          <div className={styles.MainTitle}>
            Experience the Energy of the Cross Club Pickleball League!
          </div>
          <div className={styles.Text}>
            Join the Cross Club Pickleball League where passion, competition, and community create thrilling, energetic matches!
          </div>
          <button name="registration" onClick={(e) => {navigate("/" + constants.pages.registration, {replace: true})}} className={styles.Button}>Join Now</button>
        </div>
        <div className={styles.NavButtonGroup}>
          <button 
            disabled={homeImage == 0}
            onClick={(e) => togglePicture(e)} 
            name="back" 
            className={styles.NavButton}>
              <img style={{minHeight: '75%', minWidth: '75%', maxHeight: '90%', maxWidth:'90%'}} className={styles.Icon} src="/icons/arrow-left-yellow.svg"/>
          </button>
          <button
          disabled={homeImage == homeFiles.length-1}
            onClick={(e) => togglePicture(e)} 
            name="forward" 
            className={styles.NavButton}>
              <img style={{minHeight: '75%', minWidth: '75%', maxHeight: '90%', maxWidth:'90%'}} className={styles.Icon} src="/icons/arrow-right-yellow.svg"/>
          </button>
        </div>
      </div>

      <div className={styles.MatchupsContainer}>
        <div className={styles.SubTitle} style={{color:`${constants.colors.cplWhite}`, paddingTop: '2em'}}>WEEKLY MATCHUPS</div>
        {!isLoading ? <Carousel
          carouselRef={matchupCarouselRef}
          children={
            <Fragment>
                  {currentWeekMatchups.length == 0 ? <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div className={styles.Text}>Starting Soon!</div></div> : currentWeekMatchups.map((division) => {
                    const matchups = Object.values(division)[0];
                    return(
                      <div key={matchups[0][constants.divisionId]}className={styles.Matchup}>
                        <div style={{height:'6em', width:'8em'}}><img style={{height:'100%', width:'100%'}} src='/icons/cpl-logo.svg'/></div>
                        <div className={styles.MatchupRegion}>{matchups[0][constants.region] + " " + matchups[0][constants.division] + " Division"}</div>
                        {matchups.map((matchup) => {
                          return(
                            <div key={matchup[constants.matchupId]} className={styles.MatchupRow} id={matchup[constants.matchupId]}>
                              <div className={styles.MatchupTeams}>

                                <div className={styles.TeamLogo} style={{borderLeft: `2px solid ${constants.colors.cplYellow}` }}><img src={`/logos/${matchup[constants.awayClub][constants.logo]}.png`} className={styles.Icon}/></div>
                                <div id={matchup[constants.awayTeamId]} className={styles.Team} style={{justifyContent:'flex-start'}}>
                                  <div className={styles.TeamText} style={{height:'2em', marginRight: '.5em', textAlign:'start'}}>{matchup[constants.awayName]}</div> 
                                </div>

                                <div className={styles.Vs}>VS</div>

                                <div id={matchup[constants.homeTeamId]} className={styles.Team} style={{justifyContent: 'flex-end'}}>
                                  <div className={styles.TeamText} style={{height:'2em', marginRight: '.5em', textAlign:'end'}}>{matchup[constants.homeName]}</div> 
                                </div>
                                <div className={styles.TeamLogo} style={{borderRight: `2px solid ${constants.colors.cplYellow}` }}><img src={`/logos/${matchup[constants.homeClub][constants.logo]}.png`} className={styles.Icon}/></div>
                              </div>
                              
                              <div className={styles.MatchTime}>
                                {new Date(matchup[constants.scheduledTime]).toLocaleString('en-US', {month: 'short',day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true,}).replace(',', ' -')}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}
            </Fragment>
          }/> : <LoadingSpinner/>}
      </div>
{/* <br/>
      <div className={styles.NewsletterContainer}>
        <div className={styles.SubTitle} style={{color:`${constants.colors.cplNavy}`, paddingTop: '2em'}}>NEWSLETTER</div>
        <Carousel
          carouselRef={newsLetterCarouselRef}
          children={
            <Fragment>
              {videos.map((v) => {
                return (
                  <iframe
                    width="100%"
                    height="500"
                    src={`https://www.youtube.com/embed/${v}?autoplay=1`}
                    title="YouTube Live Stream"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                )
              })}
            </Fragment>}/>
      </div> */}
<br/>
      <div className={styles.InfoContainer}>
        <div className={`${styles.Content} ${styles.PicContent}`}>
          <img style={{height: 'auto', maxWidth: '100%'}} src='pictures/Home/mission/Players-Courtyard-63.jpg'/>
        </div>
        <div className={`${styles.Content} ${styles.TextContent}`}>
          <div className={styles.TextContent}>
            <div className={styles.SubTitle}>About Cross Club Pickleball League</div>
            <div className={styles.SubText}>The Cross Club Pickleball League fosters a sense of club spirit and competition for pickleball players of all skill levels. Combining the familiarity of intraclub play with the competitive nature of tournaments, the structured team format and multiple divisions provides a unique platform for both players and club alike.</div>
          </div>
        </div>

        <div className={`${styles.Content} ${styles.TextContent}`}>
          <div className={styles.TextContent}>
            <div className={styles.SubTitle}>Our Vision</div>
            <div className={styles.SubText}>To bring a club-centric league to players everywhere, unifying them through the experience of representing their club and empowering them to achieve collective success in competitive play.</div>
          </div>
        </div>
        
        <div className={`${styles.Content} ${styles.PicContent}`}>
          <img style={{height: 'auto', maxWidth: '100%'}} src='pictures/Home/mission/The-Team-6.jpg'/>
        </div>
      </div>
<br/>
      <div className={styles.MatchupsContainer}>
        <div className={styles.SubTitle} style={{color:`${constants.colors.cplWhite}`, paddingTop: '2em'}}>WEEKLY RECAP</div>
        {!isLoading ? <Carousel
          carouselRef={recapCarouselRef}
          children={
            <Fragment>
              {lastWeekMatchups.length == 0 ? <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div className={styles.Text}>Starting Soon!</div></div> : lastWeekMatchups.map((division) => {
                const matchups = Object.values(division)[0];
                return(
                  <div key={matchups[0][constants.divisionId]}className={styles.Matchup}>
                    <div style={{height:'6em', width:'8em'}}><img style={{height:'100%', width:'100%'}} src='/icons/cpl-logo.svg'/></div>
                    <div className={styles.MatchupRegion}>{matchups[0][constants.region] + " " + matchups[0][constants.division] + " Division"}</div>
                    {matchups.map((matchup) => {
                      return(
                        <div key={matchup[constants.matchupId]} className={styles.MatchupRow} id={matchup[constants.matchupId]}>
                          <div className={styles.MatchupTeams}>

                            <div className={styles.TeamLogo} style={{borderLeft: `2px solid ${constants.colors.cplYellow}` }}><img src={`/logos/${matchup[constants.awayClub][constants.logo]}.png`} className={styles.Icon}/></div>
                            <div id={matchup[constants.awayTeamId]} className={styles.Team} style={{justifyContent:'flex-start'}}>
                              <div className={styles.TeamText} style={{height:'2em', marginRight: '.5em', textAlign:'start'}}>{matchup[constants.awayName]}</div> 
                            </div>

                            <div className={styles.ScoreContainer}>
                              <div className={styles.Score} style={{paddingLeft:'2px'}}>{matchup[constants.awayWins]}</div>
                              <div className={styles.Score} style={{paddingRight:'2px'}}>{matchup[constants.homeWins]}</div>
                            </div> 

                            <div id={matchup[constants.homeTeamId]} className={styles.Team} style={{justifyContent: 'flex-end'}}>
                              <div className={styles.TeamText} style={{height:'2em', marginRight: '.5em', textAlign:'end'}}>{matchup[constants.homeName]}</div> 
                            </div>
                            <div className={styles.TeamLogo} style={{borderRight: `2px solid ${constants.colors.cplYellow}` }}><img src={`/logos/${matchup[constants.homeClub][constants.logo]}.png`} className={styles.Icon}/></div>
                          </div>
                          
                          <div className={styles.MatchTime}>
                            {new Date(matchup[constants.scheduledTime]).toLocaleString('en-US', {month: 'short',day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true,}).replace(',', ' -')}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </Fragment>
          }/> : <LoadingSpinner/>}
      </div>

      {/* <div className={styles.NewsletterContainer}>
        <div className={styles.SubTitle} style={{color:`${constants.colors.cplNavy}`, paddingTop: '2em'}}>GALLERY</div>
        <div className={styles.GalleryContainer}>
          <div style={{height:'10em', width:'40em', backgroundColor:'red'}}></div>
          <div style={{height:'10em', width:'10em', backgroundColor:'red'}}></div>
          <div style={{height:'40em', width:'40em', backgroundColor:'red'}}></div>
          <div style={{height:'20em', width:'20em', backgroundColor:'red'}}></div>
          <div style={{height:'20em', width:'40em', backgroundColor:'red'}}></div>
          <div style={{height:'30em', width:'30em', backgroundColor:'red'}}></div>
          <div style={{height:'10em', width:'40em', backgroundColor:'red'}}></div>
          <div style={{height:'25em', width:'50em', backgroundColor:'red'}}></div>
          <div style={{height:'10em', width:'10em', backgroundColor:'red'}}></div>
          <div style={{height:'40em', width:'40em', backgroundColor:'red'}}></div>
        
        </div>
      </div>
<br/> */}
        
    </div>

  )
}

export default Home;
